export const RESUMEN_OPEN_DATA = 'Resumen OpenData';
export const RESUMEN_OPEN_DATA_MOCK = `${RESUMEN_OPEN_DATA} (MOCK)`;
export const FACTURACION = 'Facturación';
export const ANOS_EMPRESA_ACTUAL = 'Años empresa actual';
export const INGRESOS = 'Ingresos Renta';
export const DELPHI_SCORE = 'Delphi Score';

export const DNI_MOCK = '83336225A';
export const LABORAL_REGIME_AUTONOMO_MOCK = 'AUTONOMO';
export const FACTURACION_MOCK = 8500;
export const NUM_ANOS_EMPRESA_ACTUAL_MOCK = 4;
export const INGRESOS_MOCK = 65200;
export const D4A_MOCK = 342;
